<?php

define('CURRENT_TARGET', "web") ;
define('IMAGE_ASSET_PREFIX', '/') ;
define('CSS_ASSET_PREFIX', '/') ;
define('UNITER_BUILD_LEVEL', 'development') ;
define('REQUIRE_PREFIX', '') ;
define('NAMESPACE_PREFIX', '\\') ;
define('VIEW_PREFIX', '/') ;


// WEBPACK FOOTER //
// core/constants_uniter.php